import { ChangeEvent } from 'react';
import { Card, Title, Box } from '@nimbus-ds/components';
import {
  FreeShippingDeliveryMethodsDto,
  FreeShippingZoneDto,
} from '@tiendanube/common';
import useScrollToError from 'App/components/AppLayout/useScrollToError';
import { Stack } from 'commons/components';
import { CategoriesInterface } from 'domains/Marketing/components';
import { FreeShippingFormState } from 'domains/Marketing/FreeShipping/types';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import {
  CategoriesSelector,
  CombinesWithOtherDiscounts,
  ConditionsCard,
  DeliveryMethodsCard,
  DeliveryZonesSelector,
  PurchaseValue,
} from './components';

export interface FreeShippingFormProps {
  values: FreeShippingFormState;
  errors: Partial<Record<string, string>>;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onChangeMethods: (methods: FreeShippingDeliveryMethodsDto[]) => void;
  onChangeCategories: (categories: CategoriesInterface[]) => void;
  onChangeZones: (methods: FreeShippingZoneDto[]) => void;
  freeShippingId?: string;
}

export function FreeShippingForm({
  values,
  errors,
  onChange,
  onChangeMethods,
  onChangeCategories,
  onChangeZones,
  freeShippingId,
}: Readonly<FreeShippingFormProps>) {
  useScrollToError(errors);
  const showRequiredError = errors?.methods === 'empty';
  const t = useTranslationMarketing('freeShipping.settingsPage.conditions');

  return (
    <Stack column align="flex-start">
      <DeliveryMethodsCard
        methods={values.methods}
        showRequiredError={showRequiredError}
        onChange={onChangeMethods}
        onlyCheapestShipping={values.onlyCheapestShipping ?? false}
        onChangeOnlyCheapestShipping={onChange}
        freeShippingId={freeShippingId}
      />
      <Card>
        <Card.Header>
          <Stack spacing="none" justify="space-between" align="center">
            <Stack spacing="tight">
              <Title as="h4">{t('categories')}</Title>
            </Stack>
          </Stack>
        </Card.Header>
        <Card.Body>
          <Box display="flex" flexDirection="column" gap="4">
            <CategoriesSelector
              categories={values.categories}
              categoriesType={values.categoriesType}
              onChangeCategories={onChangeCategories}
              onChange={onChange}
            />
          </Box>
        </Card.Body>
      </Card>
      <ConditionsCard>
        <CombinesWithOtherDiscounts
          value={values.combinesWithOtherDiscounts}
          onChange={onChange}
        />
        <DeliveryZonesSelector
          zones={values.zones}
          zonesType={values.zonesType}
          onChange={onChange}
          onChangeZones={onChangeZones}
        />
        <PurchaseValue value={values.priceMinimum} onChange={onChange} />
      </ConditionsCard>
    </Stack>
  );
}
